import { Suspense } from 'react';
import { Outlet, matchPath, useLocation } from 'react-router-dom';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import {
  FOOTBALL,
  FOOTBALL_HOME,
} from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useIsMobile } from '@sorare/core/src/hooks/device/useIsMobile';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';

import { AppLayout } from '@sorare/gameplay/src/components/navigation/AppLayout';

import { LoyaltyBoxButton } from 'components/LoyaltyBoxButton';
import { Season26ReactivationDialog } from 'components/onboarding/Season26ReactivationDialog';
import { FootballMarketSubscriptions } from 'routing/FootballMarketSubscriptions';

const FootballLayout = () => {
  const { currentUser, footballUserProfile } = useCurrentUserContext();
  const location = useLocation();
  const isMobile = useIsMobile();
  const { forcedIntoOnboarding } = currentUser || {};
  const {
    flags: { showS26WelcomeBack = false },
  } = useFeatureFlags();

  if (
    forcedIntoOnboarding &&
    !footballUserProfile?.commonGameOnboarded &&
    (matchPath(FOOTBALL, location.pathname) ||
      matchPath(FOOTBALL_HOME, location.pathname))
  ) {
    return <Outlet />;
  }
  return (
    <AppLayout extraHeaderButton={!isMobile && <LoyaltyBoxButton />}>
      <FootballMarketSubscriptions />
      {!!showS26WelcomeBack && <Season26ReactivationDialog />}
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </AppLayout>
  );
};
export default FootballLayout;
